import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.alert-types-index-page', () => {
  void import('./internal/alert-types-index-page').then(({ default: Component }) => Component());
});
